import { Grid, Box, FormControl, MenuItem, Select } from "@mui/material";
import { Button } from "../../../library";
import { Controller, useForm } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import axios from "@helpers/axios/private.axios";

export const FilterByDate = ({ loading, setLoading, filterCallback }) => {
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    mode: "onChange",
    defaultValues: {
      company_name: "",
      start_date: null,
      end_date: null,
    },
  });

  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setCompaniesLoading(true);
        const resp = await axios.get('/common/companies');
        setCompanies(resp.data.data);
        setCompaniesLoading(false);
      } catch (e) {
        console.error("Failed to fetch companies", e);
        setCompaniesLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  const onSubmit = (formData) => {
    setLoading(true);
    const { company_name, start_date, end_date } = formData;
    const data = {
      company_name: company_name || undefined,
      start_date: start_date ? dayjs(start_date).format("YYYY-MM-DD") : undefined,
      end_date: end_date ? dayjs(end_date).format("YYYY-MM-DD") : undefined,
    };
    filterCallback(data);
  };

  const onReset = () => {
    reset();
    filterCallback();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2} sx={{ marginBottom: 4, alignItems: 'flex-end' }}>
        <Grid item xl={3} lg={6} xs={12}>
          <div className="bo-input">
            <label className="bo-input__label">
              <p className="bo-input__label-text">Company:</p>
              <div className="bo-input__wrap">
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <Controller
                      name="company_name"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          className="bo-select"
                          variant="standard"
                          MenuProps={{ className: "bo-select-content" }}
                        >
                          <MenuItem value=""><em>All Companies</em></MenuItem>
                          {companiesLoading ? (
                            <MenuItem disabled>Loading...</MenuItem>
                          ) : (
                            companies.map((el) => (
                              <MenuItem key={el} value={el}>{el}</MenuItem>
                            ))
                          )}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Box>
              </div>
            </label>
          </div>
        </Grid>
        <Grid item xl={3} lg={6} xs={12}>
          <label>From:</label>
          <Controller
            name="start_date"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker {...field} className="bo-calendar" format="DD/MM/YYYY" slotProps={{ popper: { className: "bo-calendar-popper" } }} />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xl={3} lg={6} xs={12}>
          <label>To:</label>
          <Controller
            name="end_date"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker {...field} className="bo-calendar" format="DD/MM/YYYY" slotProps={{ popper: { className: "bo-calendar-popper" } }} />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item>
          <Button type="submit" isLoading={loading} color="orange" size="middle">Search</Button>
        </Grid>
        <Grid item>
          <Button type="button" disabled={loading} onClick={onReset} color="white" size="middle">
            {/* SVG for Reset button */}
            Reset
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};